<template>
    <div class="unqualified-page">
        <div class="df df-center" style="margin-bottom: 20px">
            <unqualified-year :unQualifiedData="unQualifiedSummary" :year="requestPayload.year"></unqualified-year>
        </div>

        <div>
            <rate-qoq :unQualifiedQOQ="unQualifiedQOQ" :year="requestPayload.year">
            </rate-qoq>
        </div>

        <div>
            <unqualified-month :year="requestPayload.year" :unQualifiedData="unQualifiedSummary"></unqualified-month>
        </div>
    </div>
</template>

<script>
import { defineComponent, reactive, ref, provide } from "vue";
import {
    modelSpecificationsOption,
    PQCProductOption,
} from "@/views/productDaily/serve/option";

import { useYearOption } from "@/views/productDaily/components/quality/PassRate/serve/option";

import {
    qualityInspectionProblemRate,
    qualityInspectionProblemQOQData,
} from "@/request/view/dailyQualityInspection.js";

import { swanMachineOptions } from '@/components/cascader/option';

import unqualifiedYear from "@/views/productDaily/problem/failureRateYear.vue";
import rateQoq from "@/views/productDaily/problem/failureRateQOQ.vue";
import unqualifiedDetailsByMonth from "@/views/productDaily/components/quality/unqualified/unQualifiedSummary/detailsByMonth.vue";
import unqualifiedMonth from "@/views/productDaily/problem/failureRateMonth.vue";
import { useRoute } from "vue-router";

export default defineComponent({
    components: {
        unqualifiedYear,
        unqualifiedMonth,
        rateQoq,
        unqualifiedDetailsByMonth,
    },
    setup() {
        const { currentYear, yearOption } = useYearOption();
        const route = useRoute();
        const requestPayload = reactive({
            produceOrTpc: route.meta.produceOrTpc,
            year: currentYear,
            model: null,
        });

        const PQCkeyList = reactive([]);
        provide("PQCkeyList", PQCkeyList);
        const initPQCkeyList = () => {
            PQCkeyList.length = 0;
            PQCProductOption.filter((f) => f.label !== "包装").forEach((item) => {
                PQCkeyList.push(item.value);
            });
            PQCkeyList.push("合计");
        };

        // 不合格率汇总
        const unQualifiedSummary = ref(null);

        // 不合格环比汇总
        const unQualifiedQOQ = ref(null);

        const getunQualidiedQOQ = () => {
            unQualifiedQOQ.value = null;
            qualityInspectionProblemQOQData(requestPayload).then((res) => {
                if (
                    res.code === 200 &&
                    res.message === "成功" &&
                    res.data &&
                    Object.keys(res.data).length > 0
                ) {
                    unQualifiedQOQ.value = res.data;
                }
            });
        };

        const getUnQualifiedSummary = () => {
            unQualifiedSummary.value = null;
            qualityInspectionProblemRate(requestPayload).then((res) => {
                if (
                    res.code === 200 &&
                    res.message === "成功" &&
                    res.data &&
                    Object.keys(res.data).length > 0
                ) {
                    unQualifiedSummary.value = res.data;
                }
            });
        };

        const init = (payload) => {
            const { year, model } = payload;
            requestPayload.year = year;
            requestPayload.model = model;
            initPQCkeyList();
            getUnQualifiedSummary();
            getunQualidiedQOQ();
        };

        return {
            swanMachineOptions,
            unQualifiedQOQ,
            init,
            yearOption,
            unQualifiedSummary,
            requestPayload,
            modelSpecificationsOption,
        };
    },
});
</script>

<style lang="less" scoped>
:deep(.statistics) {
    text-align: center;
    font-weight: bold;
}

:deep(.rate-table-layout) {
    flex-flow: wrap;
}

:deep(.rate-table) {
    td {
        width: 60px;
        height: 32px;
        text-align: center;
        line-height: 32px;
    }

    .process {
        width: 120px;
    }

    .project {
        height: 94px;
    }
}
</style>